import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import { TEAM_KEY, Team, TeamResponse, createTeam } from '../utils/backend-api/teams';
import useCurrentUser from './useCurrentUser';

export default function useTeamCreate() {
  const queryClient = useQueryClient();
  const { currentUser } = useCurrentUser();
  const { mutate, mutateAsync, isLoading } = useMutation(
    (values: Pick<Team, 'name'>) => createTeam(values),
    {
      onSuccess: (data: TeamResponse) => {
        if (data.success) {
          toast.success('Team settings have been updated.');
        }
        queryClient.setQueryData([TEAM_KEY, currentUser.guid], data);
      },
      onError: (e) => {
        console.error(e);
        toast.error('Team was not saved, please try again.');
      },
    }
  );

  return {
    createTeam: mutate,
    createTeamAsync: mutateAsync,
    isTeamCreateLoading: isLoading,
  };
}
